
import 'react-toastify/dist/ReactToastify.css';
import { Link} from "react-router-dom";
import 'react-phone-input-2/lib/style.css'
import './CountryCourses.css';



export const featuresData = [
  {
    id: 1,
    title: "Australia",
    href: "/country-course-details/1",
    description:"Australia Training Services.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/aus.jpeg",
  },
  {
    id: 2,
    title: "USA",
     href: "/country-course-details/2",
    description:"United States of America Training Services.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/usa.jpeg",
  },
  {
    id: 3,
    title: "United Kingdom",
     href: "/country-course-details/3",
    description:"United Kingdom Training Services.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/uk.jpeg",
  },
  {
    id: 4,
    title: "Philippines",
     href: "/country-course-details/4",
    description:"The Philippines are developed in accordance with national laws, DOLE regulations, and relevant industry-specific requirements, while incorporating globally recognised international standards and best practices to support professional competency.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/phil.jpeg",
  },
  {
    id: 5,
    title: "United Arab Emirates",
     href: "/country-course-details/5",
    description:"UAE are developed in accordance with local federal laws and emirate-specific regulatory frameworks, while incorporating globally recognised international standards and best practices to support professional competency.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/uae.jpeg",
  },
  {
    id: 6,
    title: "Guinea",
     href: "/country-course-details/6",
    description:"Guinea Training Services.",
    thumbnail: process.env.REACT_APP_PUBLIC_STORAGE_URL+"training/guinea.jpeg",
  },
  
];


export default function CountryCourses() {
  return (
    <>
      <main className="country-courses-page">
        <section className="country-courses-section">
          <div className="country-courses-container">
        <div className="country-courses-intro">
          <p className="country-courses-eyebrow">Why QHSE International?</p>
          <h2>Training Services</h2>
          <p className="country-courses-description">
            Consists of highly competent health and safety trainers and have deep and broad knowledge in the field of Occupational Health and Safety based from their experience is truly remarkable. Our Trainers are approved to deliver local and international courses such as.
          </p>
        </div>
        <div className="country-courses-grid">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="country-course-card"
            >
              <Link to={feature.href}>
              <div className="country-course-card-content">
                <div className="country-course-number">{feature.id}</div>
                <h5>
                  {feature.title}
                </h5>
                <p className="country-course-description">
                  {feature.description}
                </p>
                <div className="country-course-image-frame">
                  <img
                    width={364}
                    height={242}
                    src={feature.thumbnail}
                    alt={`${feature.title} training services`}
                  />
                </div>
              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
      </main>
    </>
  );
}